 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"8":"stencil-ion-avatar_3-ios-entry-js","9":"stencil-ion-avatar_3-md-entry-js","10":"stencil-ion-back-button-ios-entry-js","11":"stencil-ion-back-button-md-entry-js","12":"stencil-ion-backdrop-ios-entry-js","13":"stencil-ion-backdrop-md-entry-js","14":"stencil-ion-card_5-ios-entry-js","15":"stencil-ion-card_5-md-entry-js","16":"stencil-ion-checkbox-ios-entry-js","17":"stencil-ion-checkbox-md-entry-js","18":"stencil-ion-chip-ios-entry-js","19":"stencil-ion-chip-md-entry-js","20":"stencil-ion-col_3-entry-js","21":"stencil-ion-fab_3-ios-entry-js","22":"stencil-ion-fab_3-md-entry-js","23":"stencil-ion-img-entry-js","24":"stencil-ion-infinite-scroll_2-ios-entry-js","25":"stencil-ion-infinite-scroll_2-md-entry-js","26":"stencil-ion-input-ios-entry-js","27":"stencil-ion-input-md-entry-js","28":"stencil-ion-loading-ios-entry-js","29":"stencil-ion-loading-md-entry-js","30":"stencil-ion-popover-ios-entry-js","31":"stencil-ion-popover-md-entry-js","32":"stencil-ion-progress-bar-ios-entry-js","33":"stencil-ion-progress-bar-md-entry-js","34":"stencil-ion-radio_2-ios-entry-js","35":"stencil-ion-radio_2-md-entry-js","36":"stencil-ion-reorder_2-ios-entry-js","37":"stencil-ion-reorder_2-md-entry-js","38":"stencil-ion-ripple-effect-entry-js","39":"stencil-ion-spinner-entry-js","40":"stencil-ion-split-pane-ios-entry-js","41":"stencil-ion-split-pane-md-entry-js","42":"stencil-ion-tab-bar_2-ios-entry-js","43":"stencil-ion-tab-bar_2-md-entry-js","44":"stencil-ion-tab_2-entry-js","45":"stencil-ion-text-entry-js","46":"stencil-ion-textarea-ios-entry-js","47":"stencil-ion-textarea-md-entry-js","48":"stencil-ion-toggle-ios-entry-js","49":"stencil-ion-toggle-md-entry-js","50":"stencil-ion-virtual-scroll-entry-js"}[chunkId]||chunkId) + "." + {"0":"1624ee1e","1":"e13e1157","2":"da080517","3":"f8a5cd1a","4":"90da3aef","5":"26b299d6","8":"fb583660","9":"82f30bdc","10":"2b48e0fe","11":"9a4b4786","12":"fac795c8","13":"40cf9fbb","14":"3f80ada3","15":"05481edc","16":"f4f4f0d6","17":"fb133156","18":"778c2a28","19":"d02a6281","20":"9ba7cb15","21":"aef3f2b7","22":"f30e193a","23":"3a7195dd","24":"4ef80423","25":"c8dfead7","26":"fad7a66a","27":"80f90224","28":"aa1f5279","29":"0185a533","30":"a5f9b73b","31":"cb03e010","32":"4eca76c7","33":"f988fb3e","34":"22a03096","35":"294cee4b","36":"a749e059","37":"67399512","38":"7749c78a","39":"f89a604c","40":"e9775705","41":"a7e88585","42":"df136bca","43":"656cfc8b","44":"bad38b4d","45":"81cb8c85","46":"96e81b44","47":"e2b1c61b","48":"a2f5cedc","49":"7d58c9e9","50":"bc298fbb","52":"3cba3816","53":"2e1847d8","54":"c9d3d5f1","55":"38fffab3","56":"cd5af2f5","57":"161cd9a7","58":"84828781","59":"d73106f5","60":"780201d3","61":"14032dea","62":"ca3db5b9","63":"b414c228","64":"d94f6a1c","65":"6ccd702b","66":"e7bdcc75","67":"e8854fd4","68":"ac308251","69":"7d07127f","70":"01643d7d","71":"d93c0855","72":"1fc4dea8","73":"44febdf5","74":"d3c72486","75":"f8a652e3","76":"58ebc291","77":"85748a96","78":"740032c2","79":"4b2d5bc1","80":"dd814497","81":"f47af5c5","82":"50d423a2","83":"c385519e","84":"92b1df7a","85":"a781a1d1","86":"6bf0557b","87":"d23ee363","88":"5e05540d","89":"ba964f85","90":"75c30909","91":"f6f8c8b7"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonpemma-app"] = this["webpackJsonpemma-app"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
